export type Combination = {
  value: string;
  combinations: string[];
};

export const combinations: Combination[] = [
  {
    value: "ABKI",
    combinations: ["KIAB", "KILE", "STSC"],
  },
  {
    value: "ABLE",
    combinations: ["LEKI", "LEAB"],
  },
  {
    value: "KIAB",
    combinations: ["ABKI", "ABLE", "SCST"],
  },
  {
    value: "KILE",
    combinations: ["LEKI", "LEAB"],
  },
  {
    value: "LEAB",
    combinations: ["ABLE", "ABKI", "SCST"],
  },
  {
    value: "LEKI",
    combinations: ["KILE", "KIAB", "STSC"],
  },
  {
    value: "SCST",
    combinations: ["STSC", "KIAB", "KILE"],
  },
  {
    value: "STSC",
    combinations: ["SCST", "ABLE", "ABKI"],
  },
];
